import { SET_CLIENT } from "./types";
var initialState = {
    client: undefined,
};
export function clientsReducer(state, action) {
    if (state === void 0) { state = initialState; }
    switch (action.type) {
        case SET_CLIENT:
            return Object.assign({}, state, {
                client: action.payload,
            });
        default:
            return state;
    }
}
